module.exports = __webpack_public_path__ + "img/category_21.62bdb6c8.png";